<template>
  <div
    class="mapouter"
    :style="{ 'height': `${data.MapHeight}px` }"
  >
    <div
      v-if="coordinates"
      class="gmap_canvas"
      :style="{ 'height': `${data.MapHeight}px` }"
    >
      <iframe
        width="100%"
        :height="`${data.MapHeight}px`"
        id="gmap_canvas"
        :src="`https://maps.google.com/maps?q=${coordinates}&t=&z=13&ie=UTF8&iwloc=&output=embed`"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
      >
      </iframe>
      <!-- <v-img
        v-if="url"
        :src="url"
        :lazy-src="url"
        aspect-ratio="1"
        class="grey lighten-2"
        width="100%"
        height="auto"
      /> -->
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null,
      },
    },
    data: () => ({
      coordinates: null,
      // url: `http://maps.googleapis.com/maps/api/staticmap?&size=600x400&style=visibility:on
      //       &style=feature:water%7Celement:geometry%7Cvisibility:on
      //       &style=feature:landscape%7Celement:geometry%7Cvisibility:on
      //       &markers=icon:https://www.google.com/url?sa=i&source=images&cd=&ved=2ahUKEwiS0JjozonlAhUi4YUKHZ65BwkQjRx6BAgBEAQ&url=http%3A%2F%2Fsimpleicon.com%2Fcute.html&psig=AOvVaw3K781PpR18Q9FQeCCaEX_R&ust=1570519392228622
      //       &markers=icon:https://www.google.com/url?sa=i&source=images&cd=&ved=2ahUKEwiS0JjozonlAhUi4YUKHZ65BwkQjRx6BAgBEAQ&url=http%3A%2F%2Fsimpleicon.com%2Fcute.html&psig=AOvVaw3K781PpR18Q9FQeCCaEX_R&ust=1570519392228622
      //       &markers=icon:https://www.google.com/url?sa=i&source=images&cd=&ved=2ahUKEwiS0JjozonlAhUi4YUKHZ65BwkQjRx6BAgBEAQ&url=http%3A%2F%2Fsimpleicon.com%2Fcute.html&psig=AOvVaw3K781PpR18Q9FQeCCaEX_R&ust=1570519392228622
      //       &key=AIzaSyDLr_PUL0bfUlamQkilrlnzuR0XEmbcdfg`
    }),
    computed: {
      ...mapState('app', ['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
    },
    watch: {
      'data.Lon': {
        handler: function (newValue) {
          this.coordinates = this.data.Lat && newValue ? `${this.data.Lat}%2C${newValue}` : null
        },
        deep: true
      },
      'data.Lat': {
        handler: function (newValue) {
          this.coordinates = this.data.Lon && newValue ? `${newValue}%2C${this.data.Lon}` : null
        },
        deep: true
      },
    },
    mounted () {
      if (this.data.Lat && this.data.Lon) this.coordinates = `${this.data.Lat}%2C${this.data.Lon}`
    }
  }
</script>
<style scoped>
  .mapouter {
    position: relative;
    text-align: right;
    height: 500px;
    width: 100%;
  }
  .gmap_canvas {
    overflow: hidden;
    background: none!important;
    height: 500px;
    width: 100%;
  }
</style>
